import { classNames } from './classNames';

export const Margin = {
    bind(el, binding) {
        const className = classNames('margin', {...binding.modifiers}, binding.value);
        el.className += ' ' + className;
    },
};

export const Padding = {
    bind(el, binding) {
        const className = classNames('padding', {...binding.modifiers}, binding.value);
        el.className += ' ' + className;
    },
};



// WEBPACK FOOTER //
// ./src/baseComponents/directives/Offset/Offset.js